import _ from 'lodash';

const generateMaxDate = (startDate, maxBookingDays, disabledDays) => {
  let count = 1;
  let currentDate = _.clone(startDate);
  if (_.includes(disabledDays, currentDate.isoWeekday())) {
    count = 0;
  }
  while (count < maxBookingDays) {
    currentDate = currentDate.add(1, 'days');
    if (!_.includes(disabledDays, currentDate.isoWeekday())) {
      count += 1;
    }
  }
  return currentDate;
};

export default generateMaxDate;